


















































































































































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import dicts_cache_service from '@/services/dicts_cache_service';
import { Period } from '@/services/models-service';
import PresetService from '@/services/user_preset_service';

@Component({
  name: 'InputsHeader',
  components: {
  }
})
export default class  extends Vue {
  @PropSync('presets') public localPresets!: any;
  @Prop({default: false}) public showDouble!: boolean;
  @Prop({default: true}) public showPower!: boolean;
  // показ доп срезки не обновляется "на лету" в зависимости от данных localPresets, а только после нажатия "Загрузить"
  @Prop({default: false}) public showSecondaryCut!: boolean;
  @Prop() public periodName!: string;
  @Prop() public cutName!: string;
  @Prop() public cutNameSecondary!: string;
  @Prop({default: false}) public showPowerColumns!: boolean;

  public displayPeriod: Period = new Period();
  
  public volumeUnit = 'тыс. Гкал';
  public priceUnit = 'руб./Гкал/ч';
  public costUnit = 'тыс. руб.';
  public powerUnit = 'Гкал/ч';
  public pricePowerUnit = 'руб./Гкал/ч';

  public titles = {
    volume: 'Объем тэ',
    price_te: 'Цена/Тариф за тэ',
    cost_te: 'Стоимость тэ (итого)',
    cost_te_delta: 'Стоимость тэ (корректировка)',
    power: 'Объем мощности',
    price_power: 'Цена/Тариф за мощность',
    cost_power: 'Стоимость мощности (итого)',
    cost_power_delta: 'Стоимость мощности (корректировка)',
    price_total: 'Цена/Тариф с учетом мощности (итого)',
    cost_total: 'Стоимость с учетом мощности (итого)',
  }

  get cssVars() {
    return {
      '--width': PresetService.tableWidth + 'px'
    }
  }

  get route() {
    return this.$route.name
  }

  get show_volume() {
    if((this.localPresets.losses_show_volume && this.route === 'losses')  || (this.localPresets.buy_show_volume && this.route === 'buy') ||
    (this.localPresets.sale_show_volume && this.route === 'sale') || (this.localPresets.transport_cost_show_volume && this.route === 'transport_cost') ||
    (this.localPresets.transport_gain_show_volume && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost() {
    if((this.localPresets.buy_show_cost && this.route === 'buy') || (this.localPresets.sale_show_cost && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_cost_delta() {
    if((this.localPresets.buy_show_cost_delta && this.route === 'buy') || (this.localPresets.sale_show_cost_delta && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_cost_delta && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_cost_delta && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  get show_price() {
    if((this.localPresets.buy_show_price && this.route === 'buy') || (this.localPresets.sale_show_price && this.route === 'sale') ||
    (this.localPresets.transport_cost_show_price && this.route === 'transport_cost') || (this.localPresets.transport_gain_show_price && this.route === 'transport_gain')) {
        return true;
    } else {
      return false;
    }
  }

  defineСapacity(e: any) {
    if(e.target.scrollWidth > (PresetService.tableWidth - 12) && !e.target.getAttribute('title')) {
      e.target.setAttribute('title', e.target.textContent);
    }
  }

  mounted() {
    this.displayPeriod = dicts_cache_service.periods.find((p: Period) => p.name === this.periodName);
  }
}
